<img class="generali-logo" src="/generali-logo-big.svg" title="" alt="Generali Group">
<img class="app-logo" src="/z90-cloud-data.png">
<div class="app-title">
    GC&C <br> Portfolio Management Platform
</div>
<div class="mermaid">
</div>

